import * as Yup from 'yup';
import { isValidNumber } from 'libphonenumber-js';

// https://github.com/jquense/yup/issues/59#issuecomment-259947426

Yup.addMethod(Yup.string, 'phone', function testPhone() {
  return this.test({
    name: 'phone',
    exclusive: true,
    message: 'Must be a valid phone number. Example: +14155552671',
    test: (value) => {
      try {
        // Doing Yup.string().notRequired().phone() did not work as expected, so adding
        // in the logic to allow accepting an empty value here. Not ideal but works for our project
        if (!value) return true;
        // If they didn't add +, add it to pass validation
        // const valueWithCountryCode =
        //   value.charAt(0) === '+' ? value : `+${value}`;

        return isValidNumber(value);
      } catch (e) {
        console.devLog.info(`Phone number parsing error ${e}`);
        return false;
      }
    },
  });
});
